import useSWRImmutable from 'swr/immutable';
import { InfographState } from 'types/infographTypes';

const BASE_TEMPLATE_FETCH_URL = '/api/design/getInfographDataByE1TemplateId';
const fetcher = (templateId: string) =>
  fetch(`${BASE_TEMPLATE_FETCH_URL}`, {
    method: 'POST',
    body: JSON.stringify({
      templateId,
    }),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then((res) => res.json());

export interface TemplateAPIResponse {
  id: string;
  infograph: Omit<InfographState, 'pages' | 'widgets'>;
}

export const useFetchTemplateData = (templateId: string): { data: TemplateAPIResponse | undefined; error: Error } => {
  const { data, error } = useSWRImmutable<TemplateAPIResponse>(templateId, fetcher);

  return { data, error };
};
